var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-messagelist-avatar",style:({
        'background-color': _vm.colour
    }),attrs:{"data-nick":_vm.message.nick}},[_vm._v("\n    "+_vm._s(_vm.message.nick[0])+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d79d1260","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageListAvatar.vue
// module id = w4eV
// module chunks = 1